import { getFromApiFunction } from "../apiFunctions";

const getDepartement = async (params: URLSearchParams = new URLSearchParams()) => {
  const endPoint = "/departements/";
  return getFromApiFunction(endPoint, params);
};

export { getDepartement };
